// i18n.js
import { createI18n } from 'vue-i18n'

const messages = {}

const i18n = createI18n({
    legacy: false,          // использовать Composition API (новый режим)
    locale: 'en',
    fallbackLocale: 'en',
    messages,
    silentFallbackWarn: true
})

export default i18n
